import { Row } from 'antd';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import FormButtons from '../../../core/form/FormButtons';
import LocalFileInput from '../../../core/form/LocalFileInput';
import TextInput from '../../../core/form/TextInput';
import Column from '../../../core/layout/Column';
import Dialog from '../../../core/layout/Dialog';
import Separator from '../../../core/layout/Separator';

export default class AddFileModal extends Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func,
    onReset: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    errors: PropTypes.object,
    submitting: PropTypes.bool,
    isDirty: PropTypes.func,
    values: PropTypes.object,
  };

  static defaultProps = {
    values: {},
    errors: {},
    isOpen: false,
    submitting: false,
  };

  render() {
    return (
      <Dialog title="Add File" isOpen={this.props.isOpen} onCancel={this.props.onCancel} actions={null} width={1000}>
        <form
          onSubmit={(event) => {
            event.preventDefault();
            this.props.onSubmit();
          }}
        >
          <Row>
            <Column size={12}>
              <TextInput
                required
                value={this.props.values.title}
                label="Title"
                fieldType="text"
                onChange={(value) => this.props.onChange('title', value)}
                errorText={get(this.props.errors, 'title', '')}
              />
              <TextInput
                value={this.props.values.description}
                label="Description"
                fieldType="textarea"
                onChange={(value) => this.props.onChange('description', value)}
                errorText={get(this.props.errors, 'description', '')}
              />
              <LocalFileInput
                value={get(this.props.values, 'attachment', null)}
                onChange={(value) => this.props.onChange('attachment', value)}
                label="File"
                required
                accept="image,pdf,audio,docs"
                disabled={this.props.submitting}
                errorText={get(this.props.errors, 'attachment', '')}
              />
            </Column>
          </Row>
          <Separator size="xs" />
          <FormButtons
            confirmLabel="Create"
            isDisabled={this.props.submitting}
            isSubmitting={this.props.submitting}
            onReset={this.props.onReset}
          />
        </form>
      </Dialog>
    );
  }
}
